import './lib/jquery'

document.addEventListener('DOMContentLoaded', () => {
  $('input[read_only_input="true"]').click(() => false)
})
